import React from 'react';
import './Chapters.scss';
import TextWrapPhoto from '../Photos/TextWrapPhoto';
import infographic1 from '../../Assets/infographic1.jpg';

function Chapter3() {
  const photoData = {
    imgSrc: infographic1,
    caption: '',
    float: 'right' //pass in "right" or "left"
  };

  return (
    <>
      <section className="chapter">
        <div className="chapter__headerBar" />
        <p className="chapter__title">A Ray of Light in the Darkness</p>

        <div>
          <TextWrapPhoto photoData={photoData} />
          <p className="chapter__paragraph">
            Intel’s Daniel Gutwein was no stranger to bringing digital solutions to hard-to-reach
            places. As head of Intel’s education vertical, he’s spearheaded projects across the
            globe, from teaching digital literacy in the heart of America’s largest cities to
            bringing a computer lab with robust educational resources to remote Zambia. “At Intel,”
            Gutwein says, “our purpose is to create world-changing technology that improves the
            lives of every person on the planet. For me, for my colleagues, those aren’t just words
            on paper.”
          </p>
        </div>
        <p className="chapter__paragraph">
          But despite past successes, Gutwein’s work showed him that bigger challenges lay ahead.
          “Half of the world’s population, 3.9 billion people, still don’t access the digital
          world,” Gutwein says, “but if you look at the data, between 3.4 billion and 3.5 billion of
          those people actually have access to at least a 3G or greater network.”
        </p>
        <p className="chapter__paragraph">
          Gutwein and his team discovered that there were three major barriers to digital adoption:
          1. digital literacy; 2. understanding applications—that is, the ways digital solutions can
          help; and 3. cost. His work also led him to another key piece of knowledge: Collaboration
          was the key to bringing down those barriers quickly and effectively.
        </p>
      </section>
    </>
  );
}

export default Chapter3;
